import { connect } from 'react-redux';
import { fetchAllTeams, deleteTeam } from '../../actions/actions-index';
import Teams from '../../components/Team/Teams';

const mapStateToProps = state => {
    return {
        teams: state.team,
        user: state.user,
    }
};

export default connect(
    mapStateToProps,
    { fetchAllTeams, deleteTeam }
)(Teams);



// WEBPACK FOOTER //
// ./src/containers/Team/TeamViewContainer.js